import React from "react";
import Classes from "../AddAppointment.module.css";
import SelectDropdown from "../Dropdown/SelectDropdown";
import { FUEL_TYPES, FUEL_LEVELS, REQUESTED_AMOUNTS } from "../AddAppointment";

export default function Step2Vehicle({
  draft,
  setVehicle,
  addExtraVehicle,
  setExtraVehicle,
  removeExtraVehicle,
  savedVehicles,
  onSelectSavedVehicle,
  back,
  next,
}) {
  const v = draft.vehicle;
  const canAddMore = draft.extraVehicles.length < 3;

  return (
    <form
      className={Classes.infoCon}
      onSubmit={(e) => {
        e.preventDefault();
        next();
      }}
    >
      <div className={Classes.infoConMiddle}>
        <h3 style={{ marginBottom: 10 }}>Vehicle &amp; Service Info</h3>

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <div className={Classes.flexAlign10}>
              <h5 className={Classes.label}>Select Vehicle</h5>
              <span className={"optionalText"}> <h5>Optional</h5> </span>
            </div>
            <SelectDropdown
              options={savedVehicles}
              selected={v.selectedVehicleId}
              onChange={(val) => onSelectSavedVehicle(val)}
              placeholder={savedVehicles.length ? "Choose saved vehicle" : "No saved vehicles"}
              multiple={false}
              disabled={!savedVehicles.length}
              searchPlaceholder="Search vehicles"
            />
          </div>

          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Vehicle Make</h5>
            <input
              className={Classes.inputField}
              name="make"
              value={v.make}
              onChange={(e) => setVehicle({ make: e.target.value })}
              placeholder="e.g. Ford"
            />
          </div>
        </div>

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Vehicle Model</h5>
            <input
              className={Classes.inputField}
              name="model"
              value={v.model}
              onChange={(e) => setVehicle({ model: e.target.value })}
              placeholder="e.g. F-150"
            />
          </div>

          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>License Plate Number</h5>
            <input
              className={Classes.inputField}
              name="license"
              value={v.license}
              onChange={(e) => setVehicle({ license: e.target.value })}
              placeholder="Plate"
            />
          </div>
        </div>

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Fuel Type</h5>
            <SelectDropdown
              options={FUEL_TYPES}
              selected={v.fuelTypeId}
              onChange={(val) => setVehicle({ fuelTypeId: val })}
              placeholder="Select Fuel Type"
              multiple={false}
              searchPlaceholder="Search fuel types"
            />
          </div>

          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Fuel Tank Level Estimate</h5>
            <SelectDropdown
              options={FUEL_LEVELS}
              selected={v.fuelLevelId}
              onChange={(val) => setVehicle({ fuelLevelId: val })}
              placeholder="Select Fuel Level"
              multiple={false}
              searchPlaceholder="Search fuel levels"
            />
          </div>
        </div>

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Requested Fuel Amount</h5>
            <SelectDropdown
              options={REQUESTED_AMOUNTS}
              selected={v.requestedAmount}
              onChange={(val) => setVehicle({ requestedAmount: val })}
              placeholder="Select Amount"
              multiple={false}
              searchPlaceholder="Search amounts"
            />
          </div>
        </div>

        {/* Additional vehicles */}
        <div className={Classes.flexColGroup}>
          <button
            type="button"
            className={Classes.linkBtn}
            onClick={addExtraVehicle}
            disabled={!canAddMore}
            style={!canAddMore ? { opacity: 0.6, cursor: "not-allowed" } : undefined}
          >
            + Add Additional Vehicle(s) {canAddMore ? "" : "(limit reached)"}
          </button>
        </div>

        {draft.extraVehicles.map((ev, idx) => (
          <div key={idx} className={Classes.extraCard}>
            <div className={Classes.flexBetween}>
              <h5>Additional Vehicle #{idx + 1}</h5>
              <button type="button" className={Classes.removeBtn} onClick={() => removeExtraVehicle(idx)}>
                Remove
              </button>
            </div>

            <div className={Classes.flexColGroup}>
              <div className={Classes.flexCol1}>
                <h5 className={Classes.label}>Make</h5>
                <input className={Classes.inputField} value={ev.make}
                  onChange={(e) => setExtraVehicle(idx, { make: e.target.value })}/>
              </div>
              <div className={Classes.flexCol1}>
                <h5 className={Classes.label}>Model</h5>
                <input className={Classes.inputField} value={ev.model}
                  onChange={(e) => setExtraVehicle(idx, { model: e.target.value })}/>
              </div>
            </div>

            <div className={Classes.flexColGroup}>
              <div className={Classes.flexCol1}>
                <h5 className={Classes.label}>License</h5>
                <input className={Classes.inputField} value={ev.license}
                  onChange={(e) => setExtraVehicle(idx, { license: e.target.value })}/>
              </div>
              <div className={Classes.flexCol1}>
                <h5 className={Classes.label}>Requested Fuel Amount</h5>
                <SelectDropdown
                  options={REQUESTED_AMOUNTS}
                  selected={ev.requestedAmount}
                  onChange={(val) => setExtraVehicle(idx, { requestedAmount: val })}
                  placeholder="Select Amount"
                  multiple={false}
                />
              </div>
            </div>

            <div className={Classes.flexColGroup}>
              <div className={Classes.flexCol1}>
                <h5 className={Classes.label}>Fuel Type</h5>
                <SelectDropdown
                  options={FUEL_TYPES}
                  selected={ev.fuelTypeId}
                  onChange={(val) => setExtraVehicle(idx, { fuelTypeId: val })}
                  placeholder="Fuel Type"
                  multiple={false}
                />
              </div>
              <div className={Classes.flexCol1}>
                <h5 className={Classes.label}>Fuel Tank Level</h5>
                <SelectDropdown
                  options={FUEL_LEVELS}
                  selected={ev.fuelLevelId}
                  onChange={(val) => setExtraVehicle(idx, { fuelLevelId: val })}
                  placeholder="Fuel Level"
                  multiple={false}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className={Classes.navRow}>
        <button type="button" className={Classes.backBtn} onClick={back}>
          <h5>Back</h5>
        </button>
        <button type="submit" className={Classes.saveBtn}>
          <h5>Next</h5>
        </button>
      </div>
    </form>
  );
}
